export default {
  name: 'Documentation',
  path: '/documentation',
  meta: {
    title: 'router.documentation'
  }
};
